import { useContext, useEffect, useRef } from "react";
import { RealtimeContext } from "./RealtimeProvider";

export function useRealtimeChannel(channelPath, onMessage) {
  const subscribe = useContext(RealtimeContext);
  const handlerRef = useRef(onMessage);
  handlerRef.current = onMessage;

  useEffect(() => {
    if (!subscribe || !channelPath) return undefined;
    return subscribe(channelPath, (msg) => handlerRef.current?.(msg));
  }, [subscribe, channelPath]);
}
